/**
 * Puntea catre portalul de acum, pentru o fila care nu s-a mutat inca in v4.
 * Aceeasi fisa, aceeasi fila, deschisa de portal prin `#open=` (vezi
 * ExpandRow.eventAction din general.js). Regula strangler: nimic din vechi
 * nu se opreste pana nu are inlocuitor probat.
 *
 * Exceptie: `diagnostic_reports/device_scan/` nu e fila pe fisa. `#open=`
 * n-o poate deschide. Adresa vie e cea din agentSettings.php.
 */

/** Bucata din adresa pe care o citeste `#open=` in portal: `inventoree/devicePrinters/` -> `devicePrinters`. */
export function openKey(href: string): string {
  const parts = href.split('/').filter(Boolean)
  return parts[parts.length - 1] ?? ''
}

/**
 * Destinatia puntii - sau `null` cand nu exista niciuna.
 *
 * -----------------------------------------------------------------------------
 * DE CE POATE FI NULL
 * -----------------------------------------------------------------------------
 *
 * Puntea intoarcea `/inventoree/device/{id}#open={fila}`. Pentru modulele
 * TAIATE, adresa aia nu mai duce in portalul vechi: `_remap` o trimite inapoi
 * la `/app/inventoree/device/{id}#open={fila}` - adica fix fisa pe care omul
 * sta deja, cu acelasi mesaj "fila asta e inca in portalul vechi".
 *
 * O bucla. Si una care minte: spune ca lucrul exista in alta parte, cand de
 * fapt nu mai exista nicaieri - filele acelor module ori au ecran in v4, ori
 * au fost sterse odata cu machetele vechi.
 *
 * A ramas o singura destinatie adevarata: scanarea de diagnostic, care nu e
 * fila pe fisa si chiar traieste in portalul vechi.
 *
 * Restul intorc `null`, iar panoul spune atunci ca ecranul nu e refacut inca -
 * fara sa mai ofere o usa care da in acelasi perete.
 */
export function bridgeHref(id: number, href: string): string | null {
  if (href.includes('diagnostic_reports/device_scan')) {
    return `/diagnostic_reports/device_scan/${id}/network_scan`
  }

  return null
}

/** href-ul de rezerva al unei file din Agent Settings (click-ul e preventDefault). */
export function tabFallbackHref(id: number, href: string): string {
  if (href.includes('diagnostic_reports/device_scan')) {
    return `/diagnostic_reports/device_scan/${id}/network_scan`
  }
  return `/${href}${id}`
}

export function NotYetMoved({ id, href, label }: { id: number; href: string; label: string }) {
  const there = bridgeHref(id, href)

  return (
    <div className="panel-body v4-bridge">
      <p className="color-light-grey" style={{ margin: 0 }}>
        <i className="fas fa-info-circle"></i>{' '}
        {there === null ? (
          /*
           * Fara legatura: nu exista unde. Se spune pe fata ca ecranul urmeaza,
           * in loc sa fie trimis omul intr-o bucla care il aduce inapoi aici.
           */
          <>
            <strong>{label}</strong> has not been rebuilt yet.
          </>
        ) : (
          <>
            <strong>{label}</strong> is still served by the current portal.{' '}
            <a href={there} target="_blank" rel="noopener">
              Open it there <i className="fas fa-external-link-alt font-10"></i>
            </a>
          </>
        )}
      </p>
    </div>
  )
}
